import { render, staticRenderFns } from "./SegmentBarDiagram.vue?vue&type=template&id=51aed346&"
import script from "./SegmentBarDiagram.vue?vue&type=script&lang=ts&"
export * from "./SegmentBarDiagram.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports